import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { DpFormNavigationService, DpModalService } from '@docpath/webcomponents';
import { Observable } from 'rxjs';

@Injectable()
export class FormGuard<T> implements CanDeactivate<T> {

    constructor(
        private readonly formNavigationService: DpFormNavigationService,
        private readonly modalService: DpModalService
    ) { }

    canDeactivate(): Observable<boolean> {
        return new Observable(observer => {
            if (this.formNavigationService.hasChanges()) {
                const modal = this.modalService.openQuestion('ext.form.modal.has-changes');

                modal.componentInstance.accepted.subscribe(() => {
                    observer.next(true);
                    this.formNavigationService.setUnsavedChanges(false);
                    observer.complete();
                });

                modal.componentInstance.canceled.subscribe(() => {
                    observer.next(false);
                    observer.complete();
                });
            } else {
                observer.next(true);
                observer.complete();
            }
        });
    }
}
